import styled from 'styled-components'
import NewsletterGradient from 'common/newsletter/newsletter-gradient'
import CareerProgress from 'projects/landing-ilustrations/career-progrees'
import ProjectsFaq from 'projects/faq'
import { useSubscriptionStatus } from 'querys/subscriptions'
import PricingSection from 'components/prices/pricing-section'
import Wrapper from 'common/wrapper'
import { Typography, DarkGradient } from 'common/typography'
import Divider from 'common/divider'

const PricingCardsStyled = styled.section`
  padding-block-start: 80px;
  h2 {
    max-inline-size: 900px;
    margin: 0 auto;
    ${DarkGradient};
  }
  .secondary {
    color: var(--secondary);
  }
`

function ProjectsPricing() {
  const { data: { is_active } } = useSubscriptionStatus({ product: 'PROJECTS' })
  const { data: totalSubscription } = useSubscriptionStatus({ product: 'ALL', recurring: 'YEAR' })

  return (
    <>
      {(!is_active || !totalSubscription.is_active) && (
        <PricingCardsStyled role="region" aria-labelledby="project-pricing">
          <Wrapper maxWidth={1246}>
            <PricingSection withTitle />
            <Divider color="transparent" marginVertical={24} />
            <Typography align="center" small="headline6" large="headline5">
              ¿Qué estás esperando?
              {' '}
              <span className="secondary">Inicia tu carrera profesional</span>
            </Typography>
            <Divider color="transparent" marginVertical={36} />
          </Wrapper>
        </PricingCardsStyled>
      )}
      <ProjectsFaq />
      <CareerProgress />
      <NewsletterGradient
        formName="projects"
        gradientDesktop="linear-gradient(179.54deg, #0A004E 0.39%, #3B1375 56.69%, #DB086F 115.78%)"
        gradientMobile="linear-gradient(179.54deg, #0A004E 0.64%, #3B1375 56.42%, #DB086F 113.61%)"
        urlForm="MUIEAEqaWDbWTgzGl9CXoCFLkjKufipFMzaF0XKIANtNjo3OCDRQuW-Cnw1ebygPekxGBnQCpHSHve2_OsWHRXh778ndTNc16c9qbSBogidnUdAoYxPm77qCWViTm4Aaep7XlNcazkWhMuHzFCE8FWh4lYlc7RCyrljmK8rPbfefeAnawQnkaXV8CXuRu8uWrKfq9jsV5uCpAlGJ"
      />
    </>
  )
}

export default ProjectsPricing
